import { render, staticRenderFns } from "./TermPrivacy.vue?vue&type=template&id=4f8537d5&scoped=true&"
import script from "./TermPrivacy.vue?vue&type=script&lang=js&"
export * from "./TermPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./TermPrivacy.vue?vue&type=style&index=0&id=4f8537d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8537d5",
  null
  
)

export default component.exports